import type { DevicesResponse } from '../../lib/api'

interface Props { data: DevicesResponse | null; loading?: boolean }

const ROW_LABELS: Array<{ key: 'desktop' | 'mobile' | 'tablet'; label: string }> = [
  { key: 'desktop', label: 'Desktop' },
  { key: 'mobile', label: 'Mobil' },
  { key: 'tablet', label: 'Tablet' },
]

export function DeviceBreakdown({ data, loading }: Props) {
  if (loading || !data) return <div className="empty-state">Indlæser…</div>
  const total = ROW_LABELS.reduce((s, r) => s + data.buckets[r.key].sessions, 0)
  if (total === 0) return <div className="empty-state">Ingen sessioner i perioden.</div>

  return (
    <div className="device-list">
      {ROW_LABELS.map(({ key, label }) => {
        const n = data.buckets[key].sessions
        const pct = total > 0 ? (n / total) * 100 : 0
        return (
          <div className="device-row" key={key}>
            <div className="device-row-head">
              <span>{label}</span>
              <span className="device-meta">{n} ({pct.toFixed(0)}%)</span>
            </div>
            <div className="device-bar-track">
              <div className="device-bar-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export function ConversionByDevice({ data, loading }: Props) {
  if (loading || !data) return <div className="empty-state">Indlæser…</div>
  return (
    <table className="conv-device-table">
      <thead>
        <tr>
          <th>Enhed</th>
          <th style={{ textAlign: 'right' }}>Sessions</th>
          <th style={{ textAlign: 'right' }}>Leads</th>
          <th style={{ textAlign: 'right' }}>Konv.</th>
        </tr>
      </thead>
      <tbody>
        {ROW_LABELS.map(({ key, label }) => {
          const b = data.buckets[key]
          const conv = b.sessions > 0 ? (b.leads / b.sessions) * 100 : 0
          return (
            <tr key={key}>
              <td>{label}</td>
              <td style={{ textAlign: 'right' }}>{b.sessions}</td>
              <td style={{ textAlign: 'right' }}>{b.leads}</td>
              <td style={{ textAlign: 'right' }}>{conv.toFixed(1)}%</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
